import FormEditOrAssignPermissionsBodyUsers from './FormEditOrAssignPermissionsBodyUsers';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui';
import { FormEditUserRolesBody } from '../formEditUserRoles';
import { useFormContext, useWatch } from 'react-hook-form';
import { LucideShieldX, ShieldPlus } from 'lucide-react';
import { useUserConnected } from '@/hooks';
import { useState } from 'react';
import { TFormData } from '.';

type TTabName = 'permissions' | 'user';

interface IState {
  tab: TTabName;
}

const FormEditOrAssignPermissionsBody = () => {

  const [state, setState] = useState<IState>({ tab: 'permissions' });
  const { control } = useFormContext<TFormData>();
  let _id = useWatch({ control, name: '_id' });
  const { userConnected } = useUserConnected();

  const isCurrentUser = userConnected?._id === _id;

  const handleOnValueChange = (value: string) =>
    setState(l => ({ ...l, tab: value as TTabName }));

  if (isCurrentUser) {
    return <FormEditUserRolesBody />;
  }

  return (
    <>
      <Tabs
        value={state.tab}
        onValueChange={handleOnValueChange}>
        <TabsList className='grid w-full grid-cols-2'>
          <TabsTrigger
            title='Personaliser manuellement les permissions'
            className='flex items-center space-x-2'
            value={'permissions' as TTabName}>
            <ShieldPlus size={16} />
            <span className='text-xs'>
              Personalisé
            </span>
          </TabsTrigger>
          <TabsTrigger
            title='Importer depuis un autre utilisateur'
            className='flex items-center space-x-2'
            value={'user' as TTabName}>
            <LucideShieldX size={16} />
            <span className='text-xs'>
              Depuis un utilisateur
            </span>
          </TabsTrigger>
        </TabsList>
      </Tabs>
      {
        state.tab === 'permissions' &&
        <FormEditUserRolesBody />
      }
      {
        state.tab === 'user' &&
        <FormEditOrAssignPermissionsBodyUsers />
      }
    </>
  );

};

export default FormEditOrAssignPermissionsBody;
